import { Component, TemplateRef, ViewChild, NO_ERRORS_SCHEMA } from '@angular/core';
import { InterviewerLoginComponent } from '../interviewer/interviewer-login/interviewer-login.component';
import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { LoginDataService } from '../login-data.service';
import { Router } from '@angular/router';
import { VendorService } from '../services/vendor.service';
import { AuthService } from '../services/auth.service';
import { UtilsService } from '../utils.service';
import { EncryptionService } from '../encryption.service';
import { AdminService } from '../services/admin.service';
import { CommonModule } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import { MatTabsModule } from '@angular/material/tabs';
import { MatIconModule } from '@angular/material/icon';

import { HeaderLatestComponent } from '../home/landing-root/header-latest/header-latest.component';
import { OurAppsComponent } from '../home/about-root/our-apps/our-apps.component';
import { PeopleflowFooterComponent } from '../peopleflow-footer/peopleflow-footer.component';
@Component({
  standalone: true,
  selector: 'app-common-login',
  templateUrl: './common-login.component.html',
  styleUrl: './common-login.component.scss',
  imports: [CommonModule, ReactiveFormsModule, MatFormFieldModule, MatInputModule, MatRadioModule, MatTabsModule, MatIconModule, HeaderLatestComponent, OurAppsComponent, PeopleflowFooterComponent],
  schemas: [NO_ERRORS_SCHEMA],
})
export class CommonLoginComponent {
  [key: string]: any;
  constructor() {}

  goTo(link: any) {}

  validateInterviewer() {}
}
